import { teamPlans } from '../constants';

export const getPlanById = (planId = '') => teamPlans().find(plan => plan.id === planId || plan.id === planId.replace(/_([a-z]|[A-Z])+$/, ''));
